import { Component, inject, OnDestroy } from "@angular/core";
import { Observable, of, Subscription } from "rxjs";
import { switchMap } from "rxjs/operators";
import { AppInjector } from "src/app/app.module";
import { ModuleName } from "src/app/shared/enums/ModuleName";
import { ExtractPipe } from "src/app/shared/pipes/extract.pipe";
import { TranslatePipe } from "src/app/shared/pipes/translate.pipe";
import { ZenSnackbarService } from "src/app/shared/Theme/services/zen-snackbar.service";
import { EssentialObject, EssentialObjectService } from "../services/essential-object.service";
import { GeneralService } from "../services/general.service";
import { GlobalsService } from "../services/globals.service";
import { LanguageService } from "../services/language.service";
import { LoaderService } from "../services/loader.service";
import { LocalService } from "../services/local.service";
import { ZenCDKService } from "src/app/shared/Theme/services/zen-cdk.service";
import { Status } from "../services/global-status.service";
import { ChartBaseComponent } from "@ex/module/shared/chart/chart-base.component";
import { ChartExcelExportService } from '@ex/module/core/services/chart-excel-export.service';
import { FileHelperService } from "../services/file-helper.service";
import { CriteriaResolverService } from "../services/criteria-resolver.service";
import { ZenButtonType } from "@ex/module/shared/Theme/directives/button-style.directive";

@Component({
  selector: 'base',
  template: ``
})
export abstract class BaseComponent implements OnDestroy {

  ZenButtonType =ZenButtonType;
  private _languageService = inject(LanguageService);
  private _essentialObject = inject(EssentialObjectService);
  private _localService: LocalService = inject(LocalService);
  private _zenCDK = inject(ZenCDKService);
  private _loaderService: LoaderService = inject(LoaderService);
  private _translationPipe = inject(TranslatePipe);
  private _generalService: GeneralService = inject(GeneralService);
  private _subscriptions = new Subscription()
  private _snackbarService = inject(ZenSnackbarService);
  private _extractPipe = inject(ExtractPipe);
  private _criteriaResolverService = inject(CriteriaResolverService)
  private _chartExcelExportService = inject(ChartExcelExportService)
  private _fileHelperService = inject(FileHelperService);

  public RespondentStatus = Status
  private _globalService = inject(GlobalsService);

  public md2Count = this._globalService.md2Count;
  public mdCount = this._globalService.mdCount;
  public smCount = this._globalService.smCount;
  public lgCount = this._globalService.lgCount;
  public avgCount = this._globalService.avgCount;
  public hugeCount = this._globalService.hugeCount;
  public ModuleNames = ModuleName;



  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
    console.log(this._subscriptions.closed);
  }

  protected addSubscription(subscription: Subscription) {
    this._subscriptions.add(subscription);
  }

  protected removeSubscription(subscription: Subscription) {
    const s = this._subscriptions.remove(subscription);
  }

  protected get GlobalService(): GlobalsService {
    return this._globalService;
  }

  protected get LanguageService(): LanguageService {
    return this._languageService;
  }

  protected get EssentialObject$(): Observable<EssentialObject> {
    return this._essentialObject.essentialObject;
  }

  protected get CurrentUser$() {

    const currentUser$ = this.EssentialObject$.pipe(
      switchMap((obj: EssentialObject) => {
        const tenantKey = obj?.tenant?.key;
        const companyKey = obj?.selectedEntity?.key;
        const user = obj?.user;

        if (!tenantKey || !companyKey)
          return of();

        return of(({ tenantKey: tenantKey, companyKey: companyKey, uid: user.uid, name: `${user.firstName} ${user.lastName}`, email: user.email }))
      })
    )

    return currentUser$;
  }

  protected get LocalService(): LocalService {
    return this._localService;
  }
  protected get SnackbarService(): ZenSnackbarService {
    return this._snackbarService;
  }
  protected get ZenCDKService(): ZenCDKService {
    return this._zenCDK;
  }

  protected get LoaderService(): LoaderService {
    return this._loaderService;
  }

  protected get ExtractPipe(): ExtractPipe {
    return this._extractPipe;
  }
  protected get GeneralService(): GeneralService {
    return this._generalService;
  }

  protected get FileHelper(): FileHelperService {
    return this._fileHelperService;
  }

  protected localize(value: string, language: string, module: string, variables?: string[]) {
    return this._translationPipe.transform(value, language, module, variables);
  }
  protected get CriteriaResolverService(): CriteriaResolverService {
    return this._criteriaResolverService;
  }
  protected get ChartExcelExportService(): ChartExcelExportService {
    return this._chartExcelExportService;
  }
  logData(e) {
    console.log(e);
  }

  toFixed(number, digits) {
    const value = parseFloat(number).toFixed(digits);
    return value == 'NaN' ? 0 : value;
  }
  validateCount(value, count, language, module, ready?) {
    let validatedCount = 0;
    if (ready == 'x') {
      validatedCount = this.countWord(value, count);
    } else
      validatedCount = this.countWord(this.ExtractPipe.transform(value, language), count) || 0;
    if (validatedCount > count) {
      this.SnackbarService.error(
        this._translationPipe.transform("txtWrongTextCount", language, module)
      );

      return false;
    }
    if (validatedCount <= count) {
      return true;
    }
  }


  countWord(word, count) {
    if (word?.length <= count) return word.length;
    if (word?.length > count) {
      return word.length;
    }
  }

  extractTranslations(key: string, languages: string[], module: string = ModuleName.Shared) {
    return languages.map(lang => {
      return {
        key: lang,
        name: this.localize(key, lang, module)
      }
    })
  }

}
